export default __webpack_public_path__ + "static/media/avatar.16fe228e.png";